import { render, staticRenderFns } from "./OrderHomeHeader.vue?vue&type=template&id=639b34ad&scoped=true&"
import script from "./OrderHomeHeader.vue?vue&type=script&lang=js&"
export * from "./OrderHomeHeader.vue?vue&type=script&lang=js&"
import style0 from "./OrderHomeHeader.vue?vue&type=style&index=0&id=639b34ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639b34ad",
  null
  
)

export default component.exports